module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};



//////////////////
// WEBPACK FOOTER
// ./~/rudy-match-path/~/isarray/index.js
// module id = 1356
// module chunks = 0